class PageAIRevolutionVideosCTA {
    constructor(el) {
        this.el = el;
        this.parent = this.el.parentElement;
        this.row = this.parent.parentElement;
        this.thumbs = this.row.querySelectorAll('.ai-rev-thumb')
        this.lastThumb = this.thumbs[this.thumbs.length - 1];
        this.lastThumbWatchVideo = this.lastThumb.querySelector('.watch-video');

        this.updateClasses();

        window.addEventListener('resize', this.updateClasses.bind(this));
    }

    updateClasses() {
        this.itemsCount = this.thumbs.length;
        // Determine the number of columns based on window width
        let columns;
        let columnClassPrefix;
        if (window.innerWidth < 1024) {
            columns = 2;
            columnClassPrefix = 'col-sm-';
        } else if (window.innerWidth < 1280) {
            columns = 3;
            columnClassPrefix = 'col-md-';
        } else {
            columns = 4;
            columnClassPrefix = 'col-lg-';
        }

        // Calculate items in the last row based on the number of columns
        this.itemsInLastRow = this.itemsCount % columns;

        // Remove all column size classes before adding new ones
        this.parent.className = this.parent.className.replace(/col-\w+(-\d+)?/g, '').trim();

        // Add common classes
        this.parent.classList.add('col-sm-6', 'col-md-4');
        // Determine the class to add based on the remaining items in the last row
        if (this.itemsInLastRow === 0) {
            this.parent.classList.add(`${columnClassPrefix}12`);
            this.el.style.height = 'auto';
        } else {
            const remainingColumns = columns - this.itemsInLastRow;
            this.parent.classList.add(`${columnClassPrefix}${remainingColumns * (12 / columns)}`);
            if (remainingColumns === 1) {
                this.el.style.height = '100%';
            } else {
                // get the height of last thumb .watch-video element
                const lastThumbWatchVideoHeight = this.lastThumbWatchVideo.offsetHeight;

                this.el.style.height = `${lastThumbWatchVideoHeight}px`;
            }
        }
    }

    static init() {
        const el = document.querySelector('.ai-rev-cta');

        if (el) {
            new PageAIRevolutionVideosCTA(el);
        }
    }
}

export default PageAIRevolutionVideosCTA;
